<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div class="height-100-percent">
  @if (this.Mode === 'design') {
    <div class="flex-row-top-right">
      <div class="fill-remaining-space">
        <!-- If there are instructions, display label first, then instructions then field -->
        @if (this.HasInstructions) {
          @if (this.DisplayName) {
            <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</div>
          }
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <mat-form-field appearance="outline" [floatLabel]="'always'" class="full-width">
          @if (this.ShowLabel && !HasInstructions) {
            <mat-label
              class="design-mode-field-label">
              {{this.DisplayName}} @if (this.FormField.required) {
              <span
              style="color: #EF0000;">*</span>
            }
          </mat-label>
        }
        <input matInput placeholder="{{this.htmlPlaceHolderText}}" value="{{this.htmlDefaultValue}}" disabled />
      </mat-form-field>
      <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
  </div>
}

@if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
  <div class="flex-row-top-right height-100-percent"
    [ngClass]="this.ReadOnly ? 'form-field-margin-top' : ''">
    <div class="fill-remaining-space height-100-percent">
      @if ((this.ControlType === 'Reactive Forms')) {
        @if (this.FormControl !== null) {
          <!-- If there are instructions, display label first, then instructions then field -->
          @if (this.HasInstructions) {
            @if (this.DisplayName) {
              <div class="field-label">{{this.DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
              }</div>
            }
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
          }
          @if (this.ReadOnly) {
            <div>
              <!--  TEAMS-894: KLW - If we try to use the normal behavior of href, it will go through the routing we have setup and will alway put the environment url
              before the link. To get around this, disable the href link and handle the opening of the link in a separate method -->
              <a class="html-display"
                href=""
                disabled
              (click)="this.openLink()">{{this.FormControlValue}}</a>
            </div>
          } @else {
            <mat-form-field appearance="outline" [floatLabel]="'always'" class="full-width" subscriptSizing="dynamic">
              <!-- If there are no instructions, display label integrated into the field -->
              @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                <mat-label
                  class="field-label">
                  {{this.DisplayName}} @if (this.FormField.required) {
                  <span
                  style="color: #EF0000;">*</span>
                }
              </mat-label>
            }
            @if (!this.UseGridSpecificStyling) {
              <input matInput
                type="text"
                id="{{this.MatInputId}}"
                [readonly]="this.ReadOnly"
                class="null-tooltip-mat-input"
                placeholder="{{this.htmlPlaceHolderText}}"
                [formControl]="this.FormControl"
                (blur)="this.handleOnBlur()"
                (focus)="this.handleOnFocus($event)" />
            }
            @if (this.UseGridSpecificStyling) {
              <input #gridOnlyTextArea
                matInput
                class="height-100-percent"
                placeholder="{{this.htmlPlaceHolderText}}"
                [formControl]="this.FormControl"
                (blur)="this.handleOnBlur()"
                (focus)="this.handleOnFocus($event)" />
            }
          </mat-form-field>
        }
        <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
      }
    }
  </div>
  <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
</div>
}
</div>
